import { getListingUrl } from "@utils/listingUrl"
import css from "@css/modules/Listings.module.scss"
import { getDays, getTotalPrice, originImgURL, pointOnContractYearsString, renderPoints } from "@components/Listings/listings-page-utils"
import { FavoriteBtn } from "@components/Listings/FavoriteBtn"
import Image from "next/image"
import Link from "next/link"
import { addCurrency, formatMonth } from "@utils/index"
import { ListingStatus } from "@components/Listings/ListingStatus"
import { StartRating } from "@components/StartRating"
import React from "react"
import { useRouter } from "next/navigation"
import { Listing } from "@t/Listing"
import cn from "classnames"

export function ListingItem({ listing: i }: { listing: Listing }) {
    const router = useRouter()
    return (
        <div key={i.id} className={cn(css.card)} onClick={() => router.push(getListingUrl(i), { scroll: true })}>
            <div className={css.cardBody}>
                <div className={css.cardHeader}>
                    <div className={css.cardHeaderLeft}>
                        <span className={css.cardHeaderId}>ID: {i.id}</span>
                        <div className={css.cardStatusWrap}>
                            <ListingStatus listing={i} />
                        </div>
                    </div>
                    <FavoriteBtn id={i.id} className={css.likeButton} />
                </div>
                <div className={css.cardTitle}>
                    {i?.resort?.short_name} {i?.resort?.id === 11 && Number(i.deed_exp) === 2057 && " (2057)"}
                    {originImgURL[i.origin] && <Image className={css.originImg} alt={i.origin} src={originImgURL[i.origin]} title={i.origin} width="18" height="18" />}
                </div>
                <ul className={css.cardPropsList}>
                    <li className={css.resortCell}>
                        <Link prefetch={false} href={getListingUrl(i)} scroll>
                            {i?.resort?.short_name.replace("Resort", "")}
                            {i?.resort?.id === 11 && Number(i.deed_exp) === 2057 && " (2057)"}
                            <span>
                                ID: {i?.id}{" "}
                                {originImgURL[i.origin] && <Image title={i.origin} className={css.originImg} alt={i.origin} src={originImgURL[i.origin]} width="16" height="16" />}
                            </span>
                            {/*{item.origin && <Image className={css.originImg} alt={item.origin} src={originImgURL[]} width="22" height="22" />}*/}
                        </Link>
                    </li>
                    <li className={css.pointsOnCell}>
                        Points <span>{i.points_on_contract}</span>
                    </li>
                    <li className={css.pointsCell}>
                        Pts. Available {pointOnContractYearsString}
                        <span>{renderPoints(i)}</span>
                    </li>
                    <li className={css.pppCell}>
                        Price per Pts. <span>{addCurrency(i.price_per_point)}</span>
                    </li>
                    <li className={css.useCell}>
                        Month <span>{i ? formatMonth(i.use_month) : ""}</span>
                    </li>
                    <li className={css.priceCell}>
                        Price <span>{addCurrency(getTotalPrice(i))}</span>
                    </li>
                    <li className={css.statusCell}>
                        <ListingStatus listing={i} />
                    </li>
                    <li className={css.starsCell}>
                        Deal Score
                        <span>
                            <StartRating gap={5.6} size={15} rating={i.stars} />
                        </span>
                    </li>
                    <li className={css.ageCell}>Age {getDays(i.parsed_date)}</li>
                    <li className={css.favoriteCell}>
                        <FavoriteBtn id={i.id} className={css.likeButton} />
                    </li>
                </ul>
                <div className={css.cardFooter}>
                    <hr />
                    <Link prefetch={false} href={getListingUrl(i)} className={css.viewDetails} scroll>
                        View details
                    </Link>
                </div>
            </div>
        </div>
    )
}
